module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Colombia_Cartagena_Terminal-Aerial_2011-06-10.817ee08b.jpg";